import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Image } from "primereact/image";

import girlThumbsUp from "../../../assets/images/health/submit-for-passport.png";
import useGetToken from "../../../store/selectors/get-token";
import { useTranslation } from 'react-i18next';

const SubmitForPassport = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const token = useGetToken();
    const { t } = useTranslation();

    const submitSelectedPlan = (e) => {
        e.preventDefault();

        navigate(`/get-health-quotes?token=${token}`);
    };

    return (
        <div className="content d-flex flex-row px-2" style={{ height: "90vh"}}>
            <div className="get-quote-process-container align-items-center justify-content-center vw-50">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <Image 
                        className="px-3"
                        src={girlThumbsUp}
                        width="300"
                        height="auto"
                    />
                    <span className="text-center color-heading fw-medium mb-4" style={{ fontSize: "20px" }}>
                        {`${t(`healthInsurance.negativeSubmission.title`)}`}
                    </span>
                    <span className="text-center">
                        <span className="formatted-text">{`${t(`healthInsurance.negativeSubmission.subTitle`)}`}</span>
                        <span><a href={`/ansa-help`} className="color-primary fw-bold">{`${t(`common.ansaHelp`)}`}</a></span>
                        <span className="formatted-text">{`${t(`healthInsurance.negativeSubmission.now`)}`}</span>
                    </span>
                </div>
            </div>
            
            <div className="btn-footer pb-4">
                <Button
                    label={`${t(`common.done`)}`}
                    className="btn-primary"
                    loading={loading}
                    onClick={(e) => submitSelectedPlan(e)}
                />
            </div>
        </div>
    );
};

export default SubmitForPassport;
